import { FC } from 'react';

import useTrls from 'hooks/translation/useTrls';

import {
    ActAdvertisingServiceType as ActAdvertisingServiceTypeEnum,
    ActProcessingType as ActProcessingTypeEnum,
    ActProductType as ActProductTypeEnum,
    ActSendStatus as ActSendStatusEnum,
    ActStatus as ActStatusEnum,
    ActType as ActTypeEnum,
} from 'store/models/acts';

import 'components/Admin/Reports/ActsReport/Labels/Labels.less';

export const ActType: FC<{ type: ActTypeEnum }> = ({ type }) => {
    const trl = useTrls();
    const ACT_TYPES = {
        [ActTypeEnum.All]: <span> - </span>,
        [ActTypeEnum.Clickme]: <span className="label label_clickme">{trl('admin.actsReport.types.clickme')}</span>,
        [ActTypeEnum.HH]: <span className="label label_hh">{trl('admin.actsReport.types.hh')}</span>,
    };
    return ACT_TYPES[type];
};

export const ActStatus: FC<{ status: ActStatusEnum }> = ({ status }) => {
    const trl = useTrls();

    const ACT_STATUSES = {
        [ActStatusEnum.All]: <span> - </span>,
        [ActStatusEnum.New]: <span className="label label_ready">{trl('admin.actsReport.statuses.new')}</span>,
        [ActStatusEnum.ReadyTo1C]: <span className="label label_ready">{trl('admin.actsReport.statuses.ready')}</span>,
        [ActStatusEnum.Waiting1C]: <span className="label label_wait">{trl('admin.actsReport.statuses.wait')}</span>,
        [ActStatusEnum.Finished]: <span className="label label_finish">{trl('admin.actsReport.statuses.finish')}</span>,
        [ActStatusEnum.SendingTo1C]: (
            <span className="label label_finish">{trl('admin.actsReport.statuses.sending')}</span>
        ),
        [ActStatusEnum.SentTo1C]: <span className="label label_finish">{trl('admin.actsReport.statuses.sent')}</span>,
        [ActStatusEnum.Error]: <span className="label label_finish">{trl('admin.actsReport.statuses.error')}</span>,
        [ActStatusEnum.Verified]: (
            <span className="label label_finish">{trl('admin.actsReport.statuses.verified')}</span>
        ),
        [ActStatusEnum.VerifiedError]: (
            <span className="label label_finish">{trl('admin.actsReport.statuses.verifiedError')}</span>
        ),
        [ActStatusEnum.Invalid]: <span className="label label_finish">{trl('admin.actsReport.statuses.invalid')}</span>,
    };
    return ACT_STATUSES[status];
};

export const ActProcessingType: FC<{ processingType: ActProcessingTypeEnum }> = ({ processingType }) => {
    const trl = useTrls();
    const ACT_PROCESSING_TYPES = {
        [ActProcessingTypeEnum.All]: <span> - </span>,
        [ActProcessingTypeEnum.Manual]: (
            <span className="label label_manual">{trl('admin.actsReport.processingType.manual')}</span>
        ),
        [ActProcessingTypeEnum.Auto]: (
            <span className="label label_auto">{trl('admin.actsReport.processingType.auto')}</span>
        ),
    };
    return ACT_PROCESSING_TYPES[processingType];
};

export const ActAdvertisingServiceType: FC<{ advertisingServiceType: ActAdvertisingServiceTypeEnum }> = ({
    advertisingServiceType,
}) => {
    const trl = useTrls();
    const ACT_ADVERTISING_SERVICE_TYPES = {
        [ActAdvertisingServiceTypeEnum.All]: <span> - </span>,
        [ActAdvertisingServiceTypeEnum.Advertising]: (
            <span className="label label_advertising">
                {trl('admin.actsReport.advertisingServiceType.advertising')}
            </span>
        ),
        [ActAdvertisingServiceTypeEnum.Information]: (
            <span className="label label_information">
                {trl('admin.actsReport.advertisingServiceType.information')}
            </span>
        ),
        [ActAdvertisingServiceTypeEnum.NotMarked]: (
            <span className="label label_not-marked">{trl('admin.actsReport.advertisingServiceType.notMarked')}</span>
        ),
    };
    return ACT_ADVERTISING_SERVICE_TYPES[advertisingServiceType];
};

export const ActProductType: FC<{ productType: ActProductTypeEnum }> = ({ productType }) => {
    const trl = useTrls();
    const ACT_PRODUCT_TYPES = {
        [ActProductTypeEnum.All]: <span> - </span>,
        [ActProductTypeEnum.Cpc]: <span className="label label_cpc">{trl('admin.actsReport.productType.cpc')}</span>,
        [ActProductTypeEnum.Auction]: (
            <span className="label label_auction">{trl('admin.actsReport.productType.auction')}</span>
        ),
        [ActProductTypeEnum.Segments]: (
            <span className="label label_segments">{trl('admin.actsReport.productType.segments')}</span>
        ),
    };
    return ACT_PRODUCT_TYPES[productType];
};

export const ActSendStatus: FC<{ sendStatus: ActSendStatusEnum }> = ({ sendStatus }) => {
    const trl = useTrls();
    const ACT_SEND_STATUSES = {
        [ActSendStatusEnum.All]: <span> - </span>,
        [ActSendStatusEnum.New]: (
            <span className="label label_ready">{trl('admin.actsReport.actsTable.sendStatus.new')}</span>
        ),
        [ActSendStatusEnum.Sent]: (
            <span className="label label_finish">{trl('admin.actsReport.actsTable.sendStatus.sent')}</span>
        ),
        [ActSendStatusEnum.Ignored]: (
            <span className="label label_finish">{trl('admin.actsReport.actsTable.sendStatus.ignored')}</span>
        ),
        [ActSendStatusEnum.Failed]: (
            <span className="label label_finish">{trl('admin.actsReport.actsTable.sendStatus.failed')}</span>
        ),
    };
    return ACT_SEND_STATUSES[sendStatus];
};
